import React from 'react';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import { getCurrencySymbol } from '../helpers/ticket';

const renderZonePricing = ({ serviceZone, ticket }) => {
    const price = ticket.zone_prices[serviceZone.name];

    if (ticket.payment_type === 'dd') {
        const monthly = `${
            ticket.num_monthly_payments
        } monthly payments x ${getCurrencySymbol(ticket.currency)}${ticket
            .zone_prices_monthly[serviceZone.name] || '0.00'}`;
        const deposit = `${getCurrencySymbol(ticket.currency)}${ticket
            .zone_prices_deposit[serviceZone.name] || '0.00'}`;
        return `${getCurrencySymbol(
            ticket.currency
        )}${price} (${deposit} + ${monthly})`;
    }

    if (ticket.type === 'flexi') {
        return `${getCurrencySymbol(ticket.currency)}${price} (${
            ticket.default_trips
        } trips x ${getCurrencySymbol(ticket.currency)}${
            ticket.zone_trip_prices[serviceZone.name]
        })`;
    }

    return `${getCurrencySymbol(ticket.currency)}${price}`;
};

const renderZoneOption = ({ classes, serviceZone, ticket }) => (
    <MenuItem
        className={classes.zoneMenuItem}
        key={`zone-${serviceZone.name}`}
        value={serviceZone.name}
    >
        {serviceZone.name} - {renderZonePricing({ serviceZone, ticket })}
    </MenuItem>
);

const zoneHasPrice = (serviceZone, ticket) => {
    return (
        serviceZone.name in ticket.zone_prices &&
        ticket.zone_prices[serviceZone.name] > 0
    );
};

const hasZoneStops = (passenger, service, passengerZone) => {
    const zone =
        passengerZone &&
        service.zones.find(serviceZone => serviceZone.name === passengerZone);
    return zone.stops && zone.stops.length > 0;
};

const ZonesForm = ({
    classes,
    passenger,
    service,
    ticket,
    handleChange,
    zone,
    zoneStop
}) => (
    <>
        <FormControl
            variant="outlined"
            className={classes.formControl}
            style={{ marginTop: 20 }}
        >
            <InputLabel style={{ background: 'white' }}>Zone</InputLabel>
            <Select
                id="zone"
                name="zone"
                value={zone}
                onChange={handleChange}
                variant="outlined"
                input={
                    <OutlinedInput
                        name="zone"
                        labelWidth={0}
                        id="outlined-zone"
                    />
                }
            >
                {service.zones
                    .filter(serviceZone => zoneHasPrice(serviceZone, ticket))
                    .map(serviceZone =>
                        renderZoneOption({ classes, serviceZone, ticket })
                    )}
            </Select>
        </FormControl>
        {hasZoneStops(passenger, service, zone) && (
            <FormControl variant="outlined" className={classes.formControl}>
                <InputLabel style={{ background: 'white' }}>
                    Bus stop
                </InputLabel>
                <Select
                    id="zone-stop"
                    name="zoneStop"
                    value={zoneStop}
                    onChange={handleChange}
                    variant="outlined"
                    disabled={!zone}
                    input={
                        <OutlinedInput
                            name="zoneStop"
                            labelWidth={0}
                            id="outlined-zone-stop"
                        />
                    }
                >
                    {zone &&
                        service.zones
                            .find(serviceZone => serviceZone.name === zone)
                            .stops.map(stop => (
                                <MenuItem
                                    key={`zone-stop-${stop}`}
                                    value={stop}
                                >
                                    {stop}
                                </MenuItem>
                            ))}
                </Select>
            </FormControl>
        )}
    </>
);

export default ZonesForm;
